// Border radius defaults (see app/assets/stylesheets/config/border-radius.scss)
const borderRadius = {
  small: 2,
  medium: 3,
  default: 4,
  large: 6,
  extraLarge: 10,
  rounded: 100,
}

const padding = {
  miniscule: 3,
  tiny: 6,
  small: 12,
  medium: 18,
  default: 24,
  large: 40,
  gigantic: 64,
  monstrous: 80,
  navbar: 50,
  topBottomSections: 100,
}

const text = {
  lineHeight: 1.3,
}

const fontWeights = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
}

const fontSize = {
  small: 12,
  medium: 14,
  default: 16,
  large: 18,
  extraLarge: 24,
  huge: 30,
}

const styleHelper = values => {
  return values.map(value => `${value}px`).join(' ')
}

const breakpoints = {
  // Mobile
  mobilePortrait: 420,
  mobile: 640,
  mobileLandscape: 820,

  // Desktop
  desktopSmall: 1024,
  desktopMid: 1100,
  desktop: 1200,
}

const screens = {
  // Mobile
  mobileLandscape: `@media screen and (min-width: ${breakpoints.mobileLandscape}px)`,
  mobilePortrait: `@media screen and (min-width: ${breakpoints.mobilePortrait}px)`,
  mobile: `@media screen and (min-width: ${breakpoints.mobile}px)`,

  // Desktop
  desktopSmall: `@media screen and (min-width: ${breakpoints.desktopSmall}px)`,
  desktopMid: `@media screen and (min-width: ${breakpoints.desktopMid}px)`,
  desktop: `@media screen and (min-width: ${breakpoints.desktop}px)`,
}

// Z-Index levels (see app/assets/stylesheets/config/z-index.scss for reference)
const zIndex = {
  level1: 100,
  level2: 200,
  level3: 300,
  level4: 400,
  level5: 500,
  level6: 600,
  level7: 700,
  level8: 800,
  level9: 900,
}

// Exports all the globals namespaced according to category
const globals = {
  zIndex,
  padding,
  styleHelper,
  borderRadius,
  fontWeights,
  fontSize,
  breakpoints,
  screens,
  text,
}

export default globals
